import { Box, Checkbox, styled } from '@mui/material';

export const ContractHours = styled(Box, {
  shouldForwardProp: prop => prop !== 'error',
})<{ error?: boolean; warning?: boolean }>(({ theme, error, warning }) => ({
  fontWeight: 'bold',
  fontSize: '14px',
  lineHeight: '20px',
  color: (() => {
    if (error) return theme.palette.error.main;
    if (warning) return theme.palette.warning.main;
    return theme.palette.primary.main;
  })(),
  display: 'flex',
}));

export const ContractCardCheckbox = styled(Checkbox)(({ theme }) => ({
  padding: 0,
  width: theme.spacing(2),
  height: theme.spacing(2),
}));

export const ContractCardDetailsContainer = styled(Box)(({ theme }) => ({
  fontSize: '14px',
  lineHeight: '20px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  marginTop: theme.spacing(0.5),
  paddingTop: theme.spacing(1),
  height: '76px',
}));

export const ContractCardDetailsText = styled(Box)(() => ({
  marginLeft: '30px',
  marginRight: '10px',
  position: 'absolute',
  width: 'calc(100% - 68px)',
  height: '64px',
}));

export const ContractCardName = styled(Box, {
  shouldForwardProp: prop => prop !== 'active',
})<{ active?: boolean }>(({ theme, active }) => ({
  fontSize: '14px',
  paddingLeft: '10px',
  color: active ? theme.palette.secondary.contrastText : theme.palette.secondary.main,
  fontWeight: 'bold',
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'normal',
}));

export const ContractCardFunction = styled(Box)(({ theme }) => ({
  fontSize: '14px',
  paddingLeft: '10px',
  color: theme.palette.secondary.main,
}));
